import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M11.15 2.86c.31-.32.85-.1.85.35V5c4.42 0 8 3.58 8 8 0 3.64-2.43 6.7-5.75 7.67-.63.19-1.25-.32-1.25-.97l.0066-.1163c.0437-.3841.3016-.7246.6834-.8337C16.17 18.02 18 15.72 18 13c0-3.31-2.69-6-6-6v1.79c0 .45-.54.67-.86.36L8.35 6.36c-.2-.2-.2-.51 0-.71zM5.6 8.2c.36-.48 1.08-.52 1.5-.1l.081.0938c.2733.3568.284.8495.009 1.2162C6.44 10.42 6 11.66 6 13c0 2.72 1.83 5.02 4.31 5.75.42.12.69.52.69.95l-.0063.1131c-.0667.5945-.6508 1.0357-1.2437.8569C6.43 19.7 4 16.64 4 13c0-1.8.6-3.46 1.6-4.8z"
  }],
  circles: []
};
var RestartAltIcon = function RestartAltIcon(props) {
  return renderIcon(props, iconType);
};
export { RestartAltIcon };